/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Time/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import "DesignSystem/Fonts/Inter-400.css"
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Time({
  children,
  viewPath = "/DesignSystem/Time",
  onClick,
  id = "10:00am"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let isMedia = useIsMedia()
  return (<React.Fragment
>
<button
  data-testid="Time.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bc-1-btyT': isHovered ? "rgba(0,147,201, 0.1)" : "#ffffff"}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="Time.Text"
  data-view-path={viewPath}
 style={{'--c-2-btyT': isHovered ? "rgba(0,147,201, 1)" : "#323232",'--fs-3-btyT': isMedia.mobile ? "12px" : "14px"}}
 className={`views-text ${styles.Text}`}
>
{id}
</span>
</button>
{children}
</React.Fragment>)
}